import { clearStatus } from "./status";
import { clearActiveCommunities } from "./activeCommunity";
import { queryClient } from "../../utils/queryClient";

const types = {
  LOGOUT: 'LOGOUT',
  LOGIN: 'LOGIN_SUCCESS',
  RENEW_TOKEN: 'RENEW_TOKEN',
};


// Nada de otra sesión debe sobrevivir: status y comunidad activa se persisten y
// el caché de React Query vive en memoria. Sin esto, al cambiar de cuenta se
// veía la vivienda (y sus datos en caché) de la sesión anterior.
function clearSession(dispatch) {
  dispatch(clearStatus());
  dispatch(clearActiveCommunities());
  queryClient.clear();
}


export const actions = {
  login: (user, token) => {
    return (dispatch) => {
      // También al entrar: puede quedar algo de versiones que no limpiaban al salir.
      clearSession(dispatch);
      dispatch({type: types.LOGIN, user, token});
    }
  },
  logout() {
    return (dispatch, getState) => {
      dispatch({type: types.LOGOUT});
      clearSession(dispatch);
    }
  },
};


export function renewToken(token){
  return {type: types.RENEW_TOKEN, token}
}


const initialState = {
  isLogged: false,
  user: null,
  token: null,
};

export const reducer = (state = initialState, action) => {
  const {type, user} = action;

  switch (type) {
    case types.LOGOUT:
      return Object.assign({}, initialState);

    case types.LOGIN:
      return Object.assign({}, state, {
        token: action.token,
        user: action.user,
        isLogged: true,
      });


    case types.RENEW_TOKEN:
      return Object.assign({}, state, {
        token: action.token,
      });
    
    default:
      return state;
  }
};
  